/*
 * File: cell-translation-job-cost.ts
 * Created: 2026-01-22
 * Author: Val Liu
 */

import { Component } from "vue-property-decorator";
import { BaseTableBodyCell } from "@root/components/table/core/lib/base-table-body-cell/base-table-body-cell";

@Component
export default class CellTranslationJobCost extends BaseTableBodyCell {
    get costText() {
        const raw = this.value ?? this.row?.expectedDebit ?? null;
        if (raw == null) return "-";
        const value = Number(raw);
        if (Number.isNaN(value)) return "-";
        return `${Math.ceil(value).toLocaleString()} ${this.$_("w_PointUnit")}`;
    }

    get isFailed() {
        return String(this.row?.status ?? "") === "FAILED";
    }
}
